import { computed } from 'vue';

/** Helpers used internally, but not exported to consuming repos */
/**
 * Returns back step in charting flow. If one is not found (first step), returns
 * undefined and no back button will be shown.
 */
const getBackLocation = ({ store, route }) => { var _a; return (_a = store.getters['chartingFlow/getBackStepRoute'](route)) !== null && _a !== void 0 ? _a : undefined; };
/**
 * Returns next step. If one is not found (last step), returns
 * undefined. The primary button will still show if there is a `confirmEvent`
 * available.
 */
const getNextLocation = ({ store, route }) => { var _a; return (_a = store.getters['chartingFlow/getNextStepRoute'](route)) !== null && _a !== void 0 ? _a : undefined; };
const getNextLabel = (headingParams) => {
    const isLastStep = !getNextLocation(headingParams);
    return isLastStep ? 'Save' : 'Next';
};
const getNextDisabled = ({ store, route }) => computed(() => !store.getters['chartingFlow/getIsCurrentStepValid'](route).value);
const getConfirmTooltip = ({ store, route }) => {
    const failures = store.getters['chartingFlow/getCurrentStepValidationFailures'](route);
    return failures === null || failures === void 0 ? void 0 : failures.join('\n');
};
const getConfirmLoading = ({ store, route }) => {
    var _a;
    const { orderID } = route.params;
    return (_a = store.state.chartingFlow.data[orderID !== null && orderID !== void 0 ? orderID : '']) === null || _a === void 0 ? void 0 : _a.nextButtonLoading;
};
const getConfirmEvent = ({ store, route }) => {
    const hasCompletionAction = !!store.getters['chartingFlow/getCurrentStepCompletionAction'](route);
    if (!hasCompletionAction)
        return;
    return () => store.dispatch('chartingFlow/performCompletionAction');
};
const getTitle = ({ store, route }, title) => {
    const currentStepTitle = store.getters['chartingFlow/getCurrentStepTitle'](route);
    if (currentStepTitle)
        return currentStepTitle;
    return title;
};
const chartingFlowHeadingWithNav = (title) => (headingParams) => computed(() => ({
    backLocation: getBackLocation(headingParams),
    confirmDisabled: getNextDisabled(headingParams),
    confirmEvent: getConfirmEvent(headingParams),
    confirmLoading: getConfirmLoading(headingParams),
    mobileFooter: true,
    confirmText: getNextLabel(headingParams),
    // Currently takes precedence over confirmEvent
    confirmTo: getNextLocation(headingParams),
    confirmTooltip: getConfirmTooltip(headingParams),
    leftAlignTitle: true,
    title: getTitle(headingParams, title),
}));

export { chartingFlowHeadingWithNav };
